/* =========================================================
	SITE-WIDE SCRIPTS

	1. Imports & Alpine
	2. Announcement bar
	3. Mobile nav show/hide header
	4. Events calendar enhancements
	5. Home page decorative video
	6. Promo bar modal
========================================================= */

/* MARK: 1. Imports & Alpine ---------------- */
// Alpine is required for desktop nav & modal
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

// Defines window.modalHandler, referenced by x-data on the newsletter modal.
// It must be bundled here rather than loaded as its own tag: imports evaluate
// before this module's body, so the global is guaranteed to exist by the time
// Alpine.start() walks the DOM looking for it.
import "./includes/alpine-mailchimp-ajax";

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

import UIkit from "uikit";
import "./includes/slideToggle";

/* MARK: 2. Announcement bar ---------------- */
// Requires includes/slideToggle.js
let announcementBar = document.querySelector(".announcement-bar");

if (typeof announcementBar != "undefined" && announcementBar != null) {
   let announcementBtn = document.querySelector(".announcement-button");

   // when you click the button, open and close the div:
   announcementBtn.addEventListener("click", () => {
      document.querySelector(".announcement-text").slideToggle();
      announcementBtn.classList.toggle("expanded");
   });
}

/* MARK: 3. Mobile nav show/hide header ---------------- */
// Show/hide nav based on scroll direction
// Reference: https://daily-dev-tips.com/posts/show-and-hide-a-header-based-on-scroll-direction/

// Get the mobile header
const header = document.querySelector("header.sitenav.mobile");

if (typeof header != "undefined" && header != null) {
   let lastScroll = 0;

   const throttle = (func, time = 100) => {
      let lastTime = 0;
      return () => {
         const now = new Date();
         if (now - lastTime >= time) {
            func();
            time = now;
         }
      };
   };

   const validateHeader = () => {
      const windowY = window.scrollY;
      const windowH = window.innerHeight * 0.85;
      // const scrollPointH = 300;

      if (windowY > windowH) {
         // We passed the first section, set a toggable class
         header.classList.add("is-fixed");

         // Determine if we ready to animate
         if (windowY > windowH) {
            header.classList.add("can-animate");

            if (windowY < lastScroll) {
               // Determine if we are scrolling up
               header.classList.add("scroll-up");
            } else {
               header.classList.remove("scroll-up");
            }
         } else {
            header.classList.remove("scroll-up");
         }
      } else {
         header.classList.remove("is-fixed", "can-animate");
      }

      lastScroll = windowY;
   };

   window.addEventListener("scroll", throttle(validateHeader, 100));
}

/* MARK: 4. Events calendar enhancements ---------------- */
// Get the calendar
let calendar = document.querySelector(".inline-calendar");
let calendarDates = document.querySelectorAll(".calendar-date");

// Ensure calendar exists before doing anything else
if (typeof calendar != "undefined" && calendar != null) {
   calendarDates.forEach(function (item) {
      let calDate = item.getAttribute("data-date");
      let pageDate = item.getAttribute("data-date-page");
      let calIndex = item.getAttribute("data-index");

      if (calDate == pageDate) {
         item.classList.add("current-date");
         UIkit.slider(calendar).show(calIndex);
      }
   });
}

/* MARK: 5. Home page decorative video ---------------- */
// Handle decorative video autoplay with reduced motion support
const video = document.getElementById("homeDecorativeVideo");

if (typeof video != "undefined" && video != null) {
   // Check if user prefers reduced motion
   const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
   ).matches;

   // Only autoplay if user doesn't prefer reduced motion
   if (!prefersReducedMotion) {
      video.autoplay = true;
      video.play().catch((error) => {
         // Silently handle autoplay failures for decorative content
         console.log("Decorative video autoplay failed:", error);
      });
   }

   // Optional: Pause video when not in viewport (performance optimization)
   const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
         if (entry.isIntersecting) {
            if (!prefersReducedMotion) video.play();
         } else {
            video.pause();
         }
      });
   });

   observer.observe(video);
}

/* MARK: 6. Promo bar modal ---------------- */
const promoModal = document.getElementById("promo-bar__modal");

if (typeof promoModal != "undefined" && promoModal != null) {
   const promoTrigger = document.querySelector(".promo-bar button");

   // UIkit doesn't restore focus on close, which strands keyboard users
   promoModal.addEventListener("hidden", () => promoTrigger.focus());
}
